import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Shared dashed-border empty state used by module pages before any data exists.
 * Pass an optional action (e.g. a CTA button) as children.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  children,
}: {
  icon: LucideIcon;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="rounded-lg border border-dashed border-ink-200 bg-white px-8 py-16 text-center">
      <Icon className="mx-auto h-8 w-8 text-ink-400" />
      <p className="mt-3 text-sm font-medium text-ink-700">{title}</p>
      {description && (
        <p className="mx-auto mt-1 max-w-md text-sm text-ink-500">{description}</p>
      )}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}
